import React, { forwardRef, ReactNode } from 'react';

import styles from './ClaimsHeaderContainer.scss';

const ClaimsHeaderContainer = forwardRef<HTMLDivElement, { children: ReactNode }>(({ children }, ref) => (
  <div className={styles.header} ref={ref}>
    {children}
  </div>
));

export default React.memo(ClaimsHeaderContainer);
